var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-template",
    [
      _c("template", { slot: "page-content" }, [
        _c(
          "div",
          {
            staticClass:
              "generic--template food-and-drink page-template bg-beige",
          },
          [
            _c("div", { staticClass: "relative bg-sf-color z-content" }, [
              _c("div", { staticClass: "row relative center mb4 mt4-ns" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "show-mobile relative center col-xs-12 col-sm-6 ph0",
                  },
                  [
                    _c("div", { staticClass: "w-100  col-sm-6" }, [
                      _c("img", {
                        staticClass: "img-responsive",
                        attrs: {
                          src: "/uploads/JoshWithersOSL2018_FriAtmosphere_Withers_jjw1992.jpg",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("h1", {
                      staticClass:
                        "db dn-ns f-page-title ttu tl center lh-heading pr0-ns is-blenny is-navy mw7-ns",
                      domProps: {
                        innerHTML: _vm._s(_vm.marked(_vm.page.title)),
                      },
                    }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass:
                        "db des-rest2 relative mb4 mb4-ns w-100 f18px is-tablet-regular link-bold lh-copy cms-content",
                      domProps: {
                        innerHTML: _vm._s(_vm.marked(_vm.page.intro_text)),
                      },
                    }),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "show-no-mobile relative container-fluid  mw9 center grass-top",
                },
                [
                  _c("div", { staticClass: "row relative center mb4 mt4-ns" }, [
                    _c("div", { staticClass: "w-100  col-sm-6" }, [
                      _c("img", {
                        staticClass: "img-responsive",
                        attrs: {
                          src: "/uploads/JoshWithersOSL2018_FriAtmosphere_Withers_jjw1992.jpg",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "relative col-xs-12 col-sm-6 ph0" },
                      [
                        _c("h1", {
                          directives: [
                            {
                              name: "scrollanimation",
                              rawName: "v-scrollanimation",
                            },
                          ],
                          staticClass:
                            "db dn-ns f-page-title ttu tl center lh-heading pr0-ns is-blenny is-navy mw7-ns",
                          domProps: {
                            innerHTML: _vm._s(_vm.marked(_vm.page.title)),
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "dn des-rest db-ns abs-vert-center center",
                          },
                          [
                            _c("h1", {
                              staticClass:
                                "mw7-ns tl center pl3 fiveem lh-heading ttu is-blenny is-navy",
                              domProps: {
                                innerHTML: _vm._s(_vm.marked(_vm.page.title)),
                              },
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass:
                                "db des-rest2 relative mb4 mb4-ns w-100 f18px is-tablet-regular link-bold lh-copy cms-content",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.marked(_vm.page.intro_text)
                                ),
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "show-mobile relative center col-xs-12 col-sm-6 ph0",
                },
                [
                  _c("img", {
                    staticClass: "img-responsive",
                    attrs: { src: "/uploads/Eaze_Logo-Lockup_Blue-RGB.png" },
                  }),
                  _vm._v(" "),
                  _c("div", {
                    staticClass:
                      "db des-rest2 relative mb4 mb4-ns w-100 f18px is-tablet-regular link-bold lh-copy cms-content",
                    domProps: {
                      innerHTML: _vm._s(_vm.marked(_vm.page.eaze_text)),
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "w-100  col-sm-6" }, [
                    _c("img", {
                      staticClass: "img-responsive eaze-logo",
                      attrs: { src: "/uploads/qr-code-eaze.png" },
                    }),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "show-no-mobile relative container-fluid  mw9 center grass-top2",
                },
                [
                  _c("div", { staticClass: "row relative center mb4 mt4-ns" }, [
                    _c(
                      "div",
                      { staticClass: "relative col-xs-12 col-sm-6 ph0" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "dn des-rest db-ns abs-vert-center center",
                          },
                          [
                            _c("img", {
                              staticClass: "img-responsive eaze2",
                              attrs: {
                                src: "/uploads/Eaze_Logo-Lockup_Blue-RGB.png",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "db des-rest2 relative mb4 mb4-ns w-100 f15px is-tablet-regular link-bold lh-copy cms-content",
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.page.eaze_text) +
                                    "\n                "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "w-100  col-sm-6" }, [
                      _c("img", {
                        staticClass: "img-responsive eaze-logo",
                        attrs: { src: "/uploads/qr-code-eaze.png" },
                      }),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("section", { staticClass: "relative" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "relative container-fluid center smaller-list rest-list",
                  },
                  [
                    _c(
                      "h1",
                      {
                        staticClass:
                          "center is-tablet-bold is-navy second-title",
                      },
                      [_vm._v("\n              Partners\n            ")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "row center" }, [
                      _c(
                        "div",
                        {
                          staticClass: "restaurant-border col-sm-10 mt0 mt4-ns",
                        },
                        [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "scrollanimation",
                                  rawName: "v-scrollanimation",
                                },
                              ],
                              staticClass: "row mt4",
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "row" },
                                _vm._l(
                                  _vm.page.grantees_section.grantees,
                                  function (grantee, index) {
                                    return _c(
                                      "a",
                                      {
                                        key: "grantee-item-" + index,
                                        staticClass:
                                          "col-xs-12 col-sm-3 mb3 auto-margin",
                                        attrs: {
                                          href: grantee.link,
                                          target: "_blank",
                                          title: grantee.title,
                                        },
                                      },
                                      [
                                        _c("img", {
                                          directives: [
                                            {
                                              name: "lazy",
                                              rawName: "v-lazy",
                                              value: grantee.image,
                                              expression: "grantee.image",
                                            },
                                          ],
                                          staticClass: "center w100",
                                          attrs: { title: grantee.title },
                                        }),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass:
                                            "f4 mv3 lh-copy is-black",
                                          domProps: {
                                            innerHTML: _vm._s(grantee.text),
                                          },
                                        }),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "pic-left" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "scrollanimation",
                              rawName: "v-scrollanimation",
                            },
                          ],
                          staticClass:
                            "dn db-ns bigger-img icon-image relative nt4 nl5-ns",
                        },
                        [
                          _c("img", {
                            directives: [
                              {
                                name: "scrollanimation",
                                rawName: "v-scrollanimation",
                              },
                            ],
                            staticClass: "mw21rem icon-2 icon-margin",
                            attrs: {
                              src: "/uploads/OL20-OL21_Icons/CannabisIcon/CannabisIconSVG/Cannabis_Icon_Infrared.svg",
                            },
                          }),
                          _vm._v(" "),
                          _c("img", {
                            directives: [
                              {
                                name: "scrollanimation",
                                rawName: "v-scrollanimation",
                              },
                            ],
                            staticClass: "mw21rem icon-2 icon-margin",
                            attrs: {
                              src: "/uploads/OL20-OL21_Icons/CannabisIcon/CannabisIconSVG/Cannabis_Icon_Blue.svg",
                            },
                          }),
                          _vm._v(" "),
                          _c("img", {
                            directives: [
                              {
                                name: "scrollanimation",
                                rawName: "v-scrollanimation",
                              },
                            ],
                            staticClass: "mw21rem icon-2 icon-margin",
                            attrs: {
                              src: "/uploads/OL20-OL21_Icons/CannabisIcon/CannabisIconSVG/Cannabis_Icon_Infrared.svg",
                            },
                          }),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "pic-right" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "scrollanimation",
                              rawName: "v-scrollanimation",
                            },
                          ],
                          staticClass:
                            "dn db-ns bigger-img icon-image relative nt4 nl5-ns",
                        },
                        [
                          _c("img", {
                            directives: [
                              {
                                name: "scrollanimation",
                                rawName: "v-scrollanimation",
                              },
                            ],
                            staticClass: "mw21rem icon-2 icon-margin",
                            attrs: {
                              src: "/uploads/OL20-OL21_Icons/CannabisIcon/CannabisIconSVG/Cannabis_Icon_Infrared.svg",
                            },
                          }),
                          _vm._v(" "),
                          _c("img", {
                            directives: [
                              {
                                name: "scrollanimation",
                                rawName: "v-scrollanimation",
                              },
                            ],
                            staticClass: "mw21rem icon-2 icon-margin",
                            attrs: {
                              src: "/uploads/OL20-OL21_Icons/CannabisIcon/CannabisIconSVG/Cannabis_Icon_Blue.svg",
                            },
                          }),
                        ]
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("div", {
                  staticClass: "relative container-fluid mw9 center",
                }),
              ]),
            ]),
            _vm._v(" "),
            _vm.isWindowWidthMobile == true &&
            _vm.page.featured_content_section.is_published
              ? _c(
                  "div",
                  { staticClass: "relative bg-light-blue z-content mb5" },
                  [
                    _c(
                      "section",
                      { staticClass: "relative center pv4 is-black" },
                      [
                        _c(
                          "swiper",
                          {
                            ref: "mySwiper",
                            attrs: { options: _vm.swiperOptions },
                          },
                          [
                            _c("swiper-slide", [
                              _c(
                                "div",
                                { staticClass: "relative container-fluid" },
                                [
                                  _c("div", { staticClass: "db w-100" }, [
                                    _c("img", {
                                      staticClass:
                                        "db relative center img-responsive w-100",
                                      attrs: {
                                        src: _vm.page.featured_content_section
                                          .content["0"].image,
                                        alt: _vm.page.featured_content_section
                                          .content["0"].image.alt,
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "h3",
                                      {
                                        staticClass:
                                          "f20px is-tablet-cond-bold mt4 mb3",
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.page.featured_content_section
                                                .content["0"].title
                                            ) +
                                            "\n                  "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "f15px is-tablet-regular mb3 lh-copy",
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.page.featured_content_section
                                                .content["0"].text
                                            ) +
                                            "\n                  "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass: "f15px is-tablet-bold",
                                        attrs: {
                                          title:
                                            _vm.page.featured_content_section
                                              .content["0"].link_title,
                                          href: _vm.page
                                            .featured_content_section.content[
                                            "0"
                                          ].link,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.page.featured_content_section
                                              .content["0"].button_text
                                          )
                                        ),
                                        _c("simple-svg", {
                                          staticClass: "checkout",
                                          attrs: {
                                            filepath:
                                              "/uploads/checkout-arrow.svg",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("swiper-slide", [
                              _c(
                                "div",
                                { staticClass: "relative container-fluid" },
                                [
                                  _c("div", { staticClass: "db w-100" }, [
                                    _c("img", {
                                      staticClass:
                                        "db relative center img-responsive w-100",
                                      attrs: {
                                        src: _vm.page.featured_content_section
                                          .content["1"].image,
                                        alt: _vm.page.featured_content_section
                                          .content["1"].image.alt,
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "h3",
                                      {
                                        staticClass:
                                          "f20px is-tablet-cond-bold mt4 mb3",
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.page.featured_content_section
                                                .content["1"].title
                                            ) +
                                            "\n                  "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "f15px is-tablet-regular mb3 lh-copy",
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.page.featured_content_section
                                                .content["1"].text
                                            ) +
                                            "\n                  "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass: "f15px is-tablet-bold",
                                        attrs: {
                                          title:
                                            _vm.page.featured_content_section
                                              .content["1"].link_title,
                                          href: _vm.page
                                            .featured_content_section.content[
                                            "1"
                                          ].link,
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.page.featured_content_section
                                              .content["1"].button_text
                                          )
                                        ),
                                        _c("simple-svg", {
                                          staticClass: "checkout",
                                          attrs: {
                                            filepath:
                                              "/uploads/checkout-arrow.svg",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]),
                                ]
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isWindowWidthMobile == false &&
            _vm.page.featured_content_section.is_published
              ? _c(
                  "div",
                  { staticClass: "relative bg-light-blue z-content mb5 mt4" },
                  [
                    _c("div", { staticClass: "relative container-fluid" }, [
                      _c(
                        "section",
                        { staticClass: "relative center mw8 pt5 pb5 is-black" },
                        [
                          _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-xs-12 col-sm-6 pr5-ns br-ns b--is-cream",
                              },
                              [
                                _c("img", {
                                  staticClass:
                                    "db relative center img-responsive w-100",
                                  attrs: {
                                    src: _vm.page.featured_content_section
                                      .content["0"].image,
                                    alt: _vm.page.featured_content_section
                                      .content["0"].image.alt,
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "h3",
                                  {
                                    staticClass:
                                      "f20px is-tablet-cond-bold mt4 mb3",
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.page.featured_content_section
                                            .content["0"].title
                                        ) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "f15px is-tablet-regular  mb3 lh-copy",
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.page.featured_content_section
                                            .content["0"].text
                                        ) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "f15px is-tablet-bold",
                                    attrs: {
                                      title:
                                        _vm.page.featured_content_section
                                          .content["0"].link_title,
                                      href: _vm.page.featured_content_section
                                        .content["0"].link,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.page.featured_content_section
                                          .content["0"].button_text
                                      )
                                    ),
                                    _c("simple-svg", {
                                      staticClass: "checkout",
                                      attrs: {
                                        filepath: "/uploads/checkout-arrow.svg",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-xs-12 col-sm-6 pl5-ns pt5 pt0-m pt0-l",
                              },
                              [
                                _c("img", {
                                  staticClass:
                                    "db relative center img-responsive w-100 pt4 pt0-m pt0-l",
                                  attrs: {
                                    src: _vm.page.featured_content_section
                                      .content["1"].image,
                                    alt: _vm.page.featured_content_section
                                      .content["1"].image.alt,
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "h3",
                                  {
                                    staticClass:
                                      "f20px is-tablet-cond-bold mt4 mb3",
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.page.featured_content_section
                                            .content["1"].title
                                        ) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "f15px is-tablet-regular mb3 lh-copy",
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.page.featured_content_section
                                            .content["1"].text
                                        ) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "f15px is-tablet-bold",
                                    attrs: {
                                      title:
                                        _vm.page.featured_content_section
                                          .content["1"].link_title,
                                      href: _vm.page.featured_content_section
                                        .content["1"].link,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.page.featured_content_section
                                          .content["1"].button_text
                                      )
                                    ),
                                    _c("simple-svg", {
                                      staticClass: "checkout",
                                      attrs: {
                                        filepath: "/uploads/checkout-arrow.svg",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("section", { staticClass: "relative mt6 mt0-ns mb10" }, [
              _c(
                "div",
                { staticClass: "relative container-fluid-sm mw8-5 center" },
                [
                  _c(
                    "h1",
                    {
                      staticClass: "center is-tablet-bold is-navy second-title",
                    },
                    [
                      _vm._v(
                        "\n              The Grass Lands Stage\n            "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row-one center" },
                    _vm._l(_vm.page.content_blocks, function (block, index) {
                      return _c(
                        "div",
                        { staticClass: "relative col-xs-12 col-sm-4" },
                        [
                          index === 1
                            ? _c("div", {
                                staticClass:
                                  "dn db-ns top-0 left-0 h-100 absolute center cm-border is-navy",
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          index === 1
                            ? _c("div", {
                                staticClass:
                                  "dn db-ns top-0 right-0 h-100 absolute center cm-border is-navy",
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "w-100 center ph0 ph3-ns" },
                            [
                              _c("img", {
                                directives: [
                                  {
                                    name: "lazy",
                                    rawName: "v-lazy",
                                    value: block.image,
                                    expression: "block.image",
                                  },
                                ],
                                staticClass: "mb3 center ml0 w-100 mw100",
                              }),
                              _vm._v(" "),
                              _c(
                                "h2",
                                {
                                  staticClass: "f2 tl is-tablet-bold is-black",
                                },
                                [_vm._v(_vm._s(block.title))]
                              ),
                              _vm._v(" "),
                              block.is_cocktails
                                ? _c(
                                    "div",
                                    { staticClass: "mt3" },
                                    _vm._l(block.items, function (item) {
                                      return _c("div", { staticClass: "mv2" }, [
                                        _c(
                                          "h3",
                                          {
                                            staticClass:
                                              "f3 tl is-tablet-bold is-black",
                                          },
                                          [_vm._v(_vm._s(item.title))]
                                        ),
                                        _vm._v(" "),
                                        _c("hr", {
                                          staticClass: "cocktail-divide",
                                        }),
                                        _vm._v(" "),
                                        item.description
                                          ? _c("p", {
                                              staticClass:
                                                "margin-y20 f2 mt2 is-tablet-regular is-black",
                                            })
                                          : _vm._e(),
                                        _c(
                                          "p",
                                          { staticClass: "f3 margin-y10" },
                                          [_vm._v(_vm._s(item.description))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          { staticClass: "f3 margin-y10" },
                                          [
                                            _c("b", [
                                              _vm._v(_vm._s(item.description2)),
                                            ]),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        item.description9
                                          ? _c(
                                              "p",
                                              { staticClass: "f5 margin-y10" },
                                              [
                                                _c("em", [
                                                  _vm._v(
                                                    _vm._s(item.description9)
                                                  ),
                                                ]),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("p"),
                                        _vm._v(" "),
                                        item.description3
                                          ? _c("p", {
                                              staticClass:
                                                "margin-y20 f2 mt2 is-tablet-regular is-black",
                                            })
                                          : _vm._e(),
                                        _c(
                                          "p",
                                          { staticClass: "f3 margin-y10" },
                                          [_vm._v(_vm._s(item.description3))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          { staticClass: "f3 margin-y10" },
                                          [
                                            _c("b", [
                                              _vm._v(_vm._s(item.description4)),
                                            ]),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("p"),
                                        _vm._v(" "),
                                        item.description5
                                          ? _c("p", {
                                              staticClass:
                                                "margin-y20 f2 mt2 is-tablet-regular is-black",
                                            })
                                          : _vm._e(),
                                        _c(
                                          "p",
                                          { staticClass: "f3 margin-y10" },
                                          [_vm._v(_vm._s(item.description5))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          { staticClass: "f3 margin-y10" },
                                          [
                                            _c("b", [
                                              _vm._v(_vm._s(item.description6)),
                                            ]),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("p"),
                                        _vm._v(" "),
                                        item.description7
                                          ? _c("p", {
                                              staticClass:
                                                "margin-y20 f2 mt2 is-tablet-regular is-black",
                                            })
                                          : _vm._e(),
                                        _c(
                                          "p",
                                          { staticClass: "f3 margin-y10" },
                                          [_vm._v(_vm._s(item.description7))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          { staticClass: "f3 margin-y10" },
                                          [
                                            _c("b", [
                                              _vm._v(_vm._s(item.description8)),
                                            ]),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("p"),
                                        _vm._v(" "),
                                        item.description10
                                          ? _c("p", {
                                              staticClass:
                                                "margin-y20 f2 mt2 is-tablet-regular is-black",
                                            })
                                          : _vm._e(),
                                        _c(
                                          "p",
                                          { staticClass: "f3 margin-y10" },
                                          [_vm._v(_vm._s(item.description10))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "p",
                                          { staticClass: "f3 margin-y10" },
                                          [
                                            _c("b", [
                                              _vm._v(
                                                _vm._s(item.description11)
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("p"),
                                      ])
                                    }),
                                    0
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              block.is_magic
                                ? _c(
                                    "div",
                                    { staticClass: "mt3" },
                                    _vm._l(block.items, function (item) {
                                      return _c("div", { staticClass: "mv2" }, [
                                        _c(
                                          "h3",
                                          {
                                            staticClass:
                                              "f3 tl is-tablet-bold is-black",
                                          },
                                          [_vm._v(_vm._s(item.title))]
                                        ),
                                        _vm._v(" "),
                                        item.description
                                          ? _c("p", {
                                              staticClass:
                                                "f5 mt2 is-tablet-regular is-black",
                                            })
                                          : _vm._e(),
                                        _c("h3", [
                                          _vm._v(_vm._s(item.description)),
                                        ]),
                                        _vm._v(" "),
                                        _c("p"),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "db mt2 relative is-tablet-bold f15px",
                                            attrs: {
                                              href: item.link,
                                              target: "_blank",
                                            },
                                          },
                                          [_vm._v("More →")]
                                        ),
                                      ])
                                    }),
                                    0
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showGrassLandsModal,
                    expression: "showGrassLandsModal",
                  },
                ],
                staticClass: "fixed top-0 left-0 right-0 bottom-0 bg-black-70",
                staticStyle: { "z-index": "100000" },
              },
              [
                _c("div", { staticClass: "db center w-100" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "db absolute w-100 abs-vert-center left-0 right-0 center relative mt5",
                    },
                    [
                      _c("section", { staticClass: "relative mw7 center tc" }, [
                        _c(
                          "h3",
                          { staticClass: "f3 mv3 is-lorano-bold is-white" },
                          [_vm._v("Welcome to Grass Lands")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.showNot21Message,
                                expression: "!showNot21Message",
                              },
                            ],
                          },
                          [
                            _c(
                              "h3",
                              { staticClass: "f4 mv3 is-lorano-bold is-white" },
                              [
                                _vm._v(
                                  "Are you at least 21 years of age or older?"
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex flex-row items-center justify-center relative center mv3 ",
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "db relative w-100 mw4 mh2 pv3 btn-generic has-orange-bg overflow-hidden link pointer",
                                    attrs: { title: "Yes", id: "ol20-gl-yes" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.userIs21Method()
                                      },
                                    },
                                  },
                                  [
                                    _c("span", { staticClass: "text" }, [
                                      _vm._v(
                                        "\n                      Yes\n                    "
                                      ),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "db relative w-100 mw4 mh2 pv3 btn-generic has-orange-bg overflow-hidden link pointer",
                                    attrs: { title: "No", id: "ol20-gl-no" },
                                    on: {
                                      click: function ($event) {
                                        _vm.userIsNot21Method()
                                        _vm.showNot21MessageMethod()
                                      },
                                    },
                                  },
                                  [
                                    _c("span", { staticClass: "text" }, [
                                      _vm._v(
                                        "\n                      No\n                    "
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.showNot21Message,
                                expression: "showNot21Message",
                              },
                            ],
                            staticClass: "relative center mv3 tc",
                          },
                          [
                            _c(
                              "h3",
                              { staticClass: "f4 mv3 is-lorano-bold is-white" },
                              [
                                _vm._v(
                                  "Sorry! You need to be of legal age to visit."
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "router-link",
                              {
                                staticClass:
                                  "db relative w-100 mw5 center pv3 btn-generic has-orange-bg overflow-hidden link pointer",
                                attrs: {
                                  title: "Go Home",
                                  id: "ol19-tickets-single-day-gold",
                                  to: "/",
                                },
                              },
                              [
                                _c("span", { staticClass: "text" }, [
                                  _vm._v(
                                    "\n                    Go Home\n                  "
                                  ),
                                ]),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "h1",
              {
                staticClass: "center is-tablet-bold is-navy second-title2 fs2",
              },
              [
                _vm._v(
                  "\n              License #: EVNT-21-0000005-LIC\n            "
                ),
              ]
            ),
          ]
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }